import { Component, Input, OnInit, inject } from '@angular/core';
import { Department } from 'BaseDataTypes';

import { FormsModule } from '@angular/forms';
import {
  dialogData as departmentDialogData,
  genericDialogComponent,
} from '../genericDialog';
import { DepartmentService } from 'TrainingTrackingServices/department-service';
import { UserService } from 'BaseServices/user-service';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatNativeDateModule } from '@angular/material/core';
import { MatInputModule } from '@angular/material/input';
import {
  MatDialogModule,
  MAT_DIALOG_DATA,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { GenericButtonComponent } from '../../../../../../src/app/buttons/generic-button/generic-button.component';
import { dialogInputTitleComponent } from '../../../../../../src/app/elements/dialog-input-title.component';
import { SaveButtonComponent } from '../../../../../../src/app/buttons/save-button/save-button.component';
import { DeleteButtonComponent } from '../../../../../../src/app/buttons/delete-button/delete-button.component';

@Component({
    selector: 'app-departments-dialog',
    templateUrl: './departments-dialog.component.html',
    imports: [
    FormsModule,
    MatDatepickerModule,
    MatFormFieldModule,
    MatNativeDateModule,
    MatInputModule,
    MatDialogModule,
    MatButtonModule,
    SaveButtonComponent,
    DeleteButtonComponent,
    dialogInputTitleComponent
],
    styleUrls: ['./departments-dialog.component.css'],
    providers: []
})
export class DepartmentsDialogComponent
  extends genericDialogComponent
{
  readonly data = inject<departmentDialogData<Department[]>>(MAT_DIALOG_DATA);
  @Input() department!: Department;
  @Input() departmentName!: string;

  allDepartments: Department[] = [];
  currentUser = this.userService.currentUser;
  genericButtonComponent = GenericButtonComponent;
  dialogInputTitleComponent = dialogInputTitleComponent;

  constructor(
    public override dialogRef: MatDialogRef<DepartmentsDialogComponent>,
    private userService: UserService,
    private departmentService: DepartmentService
  ) {
    super(dialogRef);
    this.department = this.data.data[0];
  }

  /**
   * Creates or updates an database object by parsing the department object to updateDepartment or createDepartment service.
   */
  saveChanges() {
    this.departmentService
      .upsertDepartment(this.department)
      .subscribe((result) => {
        this.dialogRef.close(true);
      });
  }

  /**
   * Deletes a department by using deleteDepartment service
   * @returns
   */
  deleteCourse() {
    if (!confirm('Er du sikker på at du vil slette afdelingen?')) {
      return;
    }
    this.departmentService
      .deleteDepartment(this.department.id)
      .subscribe((result) => {
        this.dialogRef.close(true);
      });
  }
}
